import { Breadcrumbs, Link, Stack, Typography, useTheme } from "@mui/material";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import { FolderIcon, KbFolderIcon, Tooltip } from "components";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";
import { centralFolderList } from "../store";

interface KbBreadcrumbsProps {
  path: Array<{
    [key: string]:
      | {
          id: string;
          kb_type: string;
        }
      | string;
  }>;
}

export const KbBreadcrumbs = ({ path }: KbBreadcrumbsProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const centralKbFolder = useAtomValue(centralFolderList);
  const handleClick = (e: any, folderId: string, isLast: boolean) => {
    e.preventDefault();
    if (!isLast) {
      if (folderId === centralKbFolder[0]?.mapping_id) {
        navigate(`/app/kb/global-kb`);
      } else {
        navigate(`/app/kb/folder/${folderId}`);
      }
    }
  };

  const handleOverviewClick = (e: any) => {
    e.preventDefault();
    navigate(`/app/kb`);
  };

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      maxItems={3}
      separator={<ArrowRightIcon fontSize="small" />}
      sx={{
        "& .MuiBreadcrumbs-separator": {
          mx: "4px", // 4px horizontal margin (0.5 * 8px = 4px)
          color: theme.palette.lightBg.low,
        },
      }}
    >
      {path.map((item, index) => {
        const [name, data] = Object.entries(item)[0];
        const isLast = index === path.length - 1;
        const folderId = typeof data === "object" ? data.id : data;

        return isLast ? (
          <Tooltip title={name}>
            <Stack
              direction={"row"}
              sx={{ gap: "4px", maxWidth: "160px", mb: "2px" }}
            >
              {/* <KbFolderIcon sx={{ width: "16px", height: "16px" }} /> */}
              <Typography
                key={folderId}
                variant="body-small"
                color={theme.palette.lightBg.low}
                mt={"3px"}
                noWrap
                overflow="hidden"
                textOverflow="ellipsis"
              >
                {name}
              </Typography>
            </Stack>
          </Tooltip>
        ) : (
          <Tooltip title={name}>
            <Stack
              direction={"row"}
              sx={{ gap: "4px", maxWidth: "160px", mb: "2px" }}
            >
              <Link
                key={folderId}
                onClick={(e) => handleClick(e, folderId, isLast)}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                  ...theme.typography["link-xs"],
                }}
              >
                {name}
              </Link>
            </Stack>
          </Tooltip>
        );
      })}
    </Breadcrumbs>
  );
};
